var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle, _circle2, _circle3, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle4, _circle5, _path18, _circle6, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSomethngWentWrongIlls(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 910,
    height: 382,
    viewBox: "0 0 910 382",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420.909 277.752C419.723 301.474 520.458 319.042 549.495 290.574C585.792 254.99 607.282 371.773 675.967 371.773C711.051 371.773 770.567 345.77 797.598 260.148",
    stroke: "black",
    strokeWidth: 1.95347,
    strokeDasharray: "13.67 13.67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M233.543 152.861C319.861 152.536 496.518 152.08 512.597 152.861C536.893 174.261 517.934 194.794 505.418 202.385L530.021 214.136C523.073 207.693 530.24 212.763 535.604 216.803L530.021 214.136C531.338 215.358 533.163 216.993 535.604 219.128C550.918 232.523 530.205 256.335 517.934 266.567C532.07 279.217 515.48 298.193 505.418 306.099H457.193C466.617 308.704 457.684 326.718 452.039 335.4H262.823C251.337 332.795 258.037 322.222 262.823 317.261H427.743C438.345 311.308 432.161 305.169 427.743 302.844H258.037C244.49 296.146 252.392 287.961 258.037 284.705H494.742C510.645 279.496 505.049 270.443 500.264 266.567H457.193H199.873C182.498 254.289 192.633 246.258 199.873 243.778H517.934C533.543 235.22 524.438 227.81 517.934 225.174H488.116H297.058C279.388 215.128 289.696 205.796 297.058 202.385H457.193C479.87 192.339 466.642 183.413 457.193 180.206H421.382H237.408C197.83 166.924 218.34 156.442 233.543 152.861Z",
    fill: "#FB7C51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M781.326 212.2C784.441 213.107 790.743 216.029 791.033 220.456L793.528 218.777C792.848 215.844 789.681 209.768 782.46 208.934",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M790.741 220.565C788.618 222.009 784.561 227.11 785.312 235.963C786.064 244.816 791.987 251.662 804.364 250.526C810.538 248.605 822.138 242.047 819.144 231.185C815.401 217.606 804.685 213.276 794.042 218.707",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M864.917 108.707C869.288 107.151 880.178 105.487 888.767 111.276C897.355 117.066 903.903 125.936 906.103 129.647C909.588 137.748 912.562 157.908 896.575 173.741C880.588 189.574 855.711 180.338 845.271 173.741",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M836.714 198.125L847.893 202.354L854.086 179.695",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M639.694 280.333L642.329 286.188L697.953 255.449L690.048 244.031",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M764.743 264.675L761.653 263.812M828.897 87.6087C835.063 89.0172 844.656 98.0911 833.706 123.12C822.757 148.148 814.805 179.988 812.198 192.779C813.257 200.6 819.677 213.114 836.884 200.6L878.191 64.948L733.495 36.8398L725.677 59.1215M828.897 87.6087C803.057 80.2742 758.254 67.7448 725.677 59.1215M828.897 87.6087C817.35 85.0251 810.695 93.1156 808.811 97.4839L761.653 263.812M725.677 59.1215C708.864 54.6707 695.307 51.2605 689.297 50.1423C671.641 46.8576 668.254 58.6963 668.767 65.0262L625.142 225.67L761.653 263.812",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M822.212 205.793L781.729 195.598",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M640.865 169.964L637.352 163.23L579.972 195.141L629.155 284.723L685.071 255.155L678.045 241.396",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 595.634,
    cy: 127.074,
    r: 8.05071,
    fill: "#FB7C51"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.681,
    cy: 8.91008,
    r: 8.05071,
    fill: "#FB7C51"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 860.249,
    cy: 244.031,
    r: 8.05071,
    fill: "#FB7C51"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M873.795 106.635L887.179 59.438L746.633 33.3359L744.401 38.3247",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M854.985 141.465L860.145 148.483C860.868 149.687 863.221 150.96 866.853 146.419C870.486 141.878 878.206 131.317 881.612 126.604C885.086 123.645 891.416 120.432 888.94 131.248L866.853 163.242C865.409 165.856 861.611 169.124 857.978 161.281L852.198 151.063",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M780.587 198.059C781.42 200.328 781.69 206.745 776.106 214.258",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M783.206 196.109C784.733 198.379 785.108 211.274 774.873 218.787",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M678.79 87.9887C682.753 84.3696 686.699 80.732 690.676 77.1294C691.873 76.0458 692.907 74.6667 694.382 74.0111C694.629 73.9013 695.614 75.0859 695.776 75.2768C697.293 77.07 698.093 79.8885 698.894 82.0638C700.116 85.38 700.915 88.8296 703.297 91.6206C704.092 92.5523 705.777 94.262 707.075 94.262C709.921 94.262 711.737 93.2929 714.119 91.749C717.424 89.6069 720.148 87.3569 723.786 85.7141C725.777 84.8149 727.6 85.9115 728.28 87.952C729.442 91.4364 729.955 95.045 731.105 98.5544C731.552 99.9192 732.527 103.276 734.297 103.58C738.685 104.335 742.304 103.585 745.963 101.049C749.415 98.656 752.779 95.9596 754.915 92.2993C755.966 90.4973 761.13 93.8892 761.848 94.7757C763.412 96.704 763.798 100.082 764.637 102.37C765.294 104.162 765.723 107.218 767.682 108.13C771.801 110.045 774.36 105.389 777.183 103.507",
    stroke: "#FB7C51",
    strokeWidth: 2.46477,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M668.823 123.743L673.417 112.66L775.009 138.982L771.226 150.757L668.823 123.743Z",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M660.495 146.208L665.088 135.125L766.68 161.447L762.897 173.222L660.495 146.208Z",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M652.444 171.731L657.038 160.648L758.63 186.97L754.847 198.746L652.444 171.731Z",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M645.48 196.966L650.073 185.883L751.666 212.204L747.883 223.98L645.48 196.966Z",
    stroke: "#FB7C51",
    strokeWidth: 0.821589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 802.425,
    cy: 233.537,
    r: 14.2258,
    fill: "#FB7C51",
    stroke: "#FB7C51",
    strokeWidth: 1.13853
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.458,
    cy: 271.48,
    r: 38.1881,
    stroke: "#FB7C51",
    strokeWidth: 2.0047
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.956055 356.108C5.51843 343.251 22.7308 318.034 55.0811 320.025C87.4314 322.017 103.814 344.91 107.961 356.108",
    stroke: "#FB7C51",
    strokeWidth: 2.0047
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.151,
    cy: 245.351,
    r: 38.1881,
    stroke: "#FB7C51",
    strokeWidth: 2.0047
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6484 329.979C98.2108 317.122 115.423 291.905 147.773 293.896C180.124 295.888 196.506 318.781 200.654 329.979",
    stroke: "#FB7C51",
    strokeWidth: 2.0047
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M177.647 349.462C194.361 374.736 238.06 408.162 279.151 339.678C330.513 254.073 162.972 128.112 299.94 125.666C409.515 123.709 418.157 192.519 408.781 227.168",
    stroke: "black",
    strokeWidth: 1.95347,
    strokeDasharray: "13.67 13.67"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M443.58 200.457L432.781 226.733",
    stroke: "#FB7C51",
    strokeWidth: 1.95347
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M468.324 227.39L442.108 238.334",
    stroke: "#FB7C51",
    strokeWidth: 1.95347
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M464.457 269.27L438.18 252.945",
    stroke: "#FB7C51",
    strokeWidth: 1.95347
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M382.056 232.387L388.508 248.087",
    stroke: "#FB7C51",
    strokeWidth: 1.95347
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M367.272 248.476L382.936 255.016",
    stroke: "#FB7C51",
    strokeWidth: 1.95347
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M369.583 273.5L385.283 263.746",
    stroke: "#FB7C51",
    strokeWidth: 1.95347
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethngWentWrongIlls);
export default __webpack_public_path__ + "static/media/SomethngWentWrongIlls.d42c74a50298f74ad59071af4117d9cd.svg";
export { ForwardRef as ReactComponent };